<template>
  <div class="download-module-background">
    <div class="download-module-banner">
      <div class="download-module-container">
        <div class="download-module-banner-title">MODULE</div>
      </div>

      <img
        class="download-module-banner-img"
        src="../../assets/about/banner.png"
      />
    </div>
    <div class="download-module-container">
      <div class="download-module-content">
        <div class="download-module-content-title">
          <div class="download-module-content-title-text">MODULE简介</div>
          <div class="download-module-line"></div>
        </div>
        <div class="download-module-content-info">
          <!-- <p class="download-module-content-info-text">在发布PWmat的同时，我们也提供一些基于PWmat的顶层模块（MODULE）供PWmat用户下载使用。这些模块在PWmat的基础上，能够进行一些特殊的计算，例如：声子谱、结构搜索等</p> -->
          <p class="download-module-content-info-text">
            在PWmat的基础功能上，我们针对用户的使用需求开发了一些顶层模块（MODULE）。
            这些MODULE中的一部分是与已有的优秀工具的接口，一部分是以PWmat的计算结果为基础得到实际需要的物理量，一部分则是为特定的计算需求而设计的计算流程。
            这些MODULE涵盖了物质结构，基础性质，针对大体系的计算以及机器学习力场等，功能全面，操作方便，欢迎用户下载和使用。详情请见
            <a
              target="_blank"
              title="module功能大全.pdf 下载"
              :href="MODULE_DOWNLOAD + 'module功能大全.pdf'"
              download
              >说明文档</a
            >，文档中附有所有MODULE的链接。
          </p>
        </div>

        <!--        <div class="download-module-content-img">
        <a target="_blank" title="module功能大全.pdf 下载" href="../../assets/download/module功能大全.pdf" download="module功能大全.pdf">
          <img class="download-module-content-img-png" src="../../assets/download/module.png">
        </a>
       </div> -->

        <div class="download-module-menu">
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
            background-color="rgba(73,145,201,1)"
            text-color="rgba(240,240,240,1)"
            size="large"
            active-text-color="rgba(240,240,240,1)"
          >
            <el-submenu index="1">
              <template slot="title">物质结构</template>
              <el-menu-item index="1-1">结构搜索</el-menu-item>
              <el-menu-item index="1-2">无序结构</el-menu-item>
              <el-menu-item index="1-3">分子动力学数据处理</el-menu-item>
              <el-menu-item index="1-4">CIF 文件转换与结构处理</el-menu-item>
            </el-submenu>

            <el-submenu index="2">
              <template slot="title">电子结构及声子计算</template>
              <el-menu-item index="2-1">电子结构</el-menu-item>
              <el-menu-item index="2-2">声子计算</el-menu-item>
            </el-submenu>

            <el-submenu index="3">
              <template slot="title">光、磁、力学和极化性质</template>
              <el-menu-item index="3-1">光学性质</el-menu-item>
              <el-menu-item index="3-2">磁学性质</el-menu-item>
              <el-menu-item index="3-3">力学性质</el-menu-item>
              <el-menu-item index="3-4">极化性质</el-menu-item>
            </el-submenu>

            <el-menu-item index="4">缺陷性质</el-menu-item>

            <el-menu-item index="5">电化学性质</el-menu-item>

            <el-menu-item index="6">输运性质</el-menu-item>

            <el-menu-item index="7">超快动力学过程</el-menu-item>
            <el-menu-item index="8">Beyond DFT</el-menu-item>

            <el-menu-item index="9">电子束辐照分解</el-menu-item>
            <el-menu-item index="10">大体系计算</el-menu-item>
            <el-menu-item index="11">机器学习力场</el-menu-item>
            <el-menu-item index="12">所有</el-menu-item>
          </el-menu>
        </div>

        <div class="download-module-content-title">
          <div class="download-module-content-title-text">{{ moduleName }}</div>
          <div class="download-module-line"></div>
        </div>
        <div class="download-module-content-info">
          <table class="download-module-table">
            <tr class="download-module-th">
              <th class="download-module-text-th"></th>
              <th class="download-module-text-th">名称</th>
              <th class="download-module-text-th">简介</th>
            </tr>
            <tbody v-for="(file, index) in pageData" :key="index">
              <tr class="download-module-td" @click="showModuleInfo(file.id)">
                <td class="download-module-text-td">
                  {{ (currentPage - 1) * pageSize + index + 1 }}
                </td>
                <td class="download-module-text-td">
                  <a class="download-module-a">{{ file.name }}</a>
                </td>
                <td class="download-module-text-td">{{ file.summary }}</td>
              </tr>
              <tr v-show="isShowModuleInfo && showModuleInfoId === file.id">
                <td class="download-module-td-info" colspan="3">
                  <div
                    class="download-module-content-info-text-td"
                    v-show="file.course_url"
                  >
                    教程：<a
                      class="download-module-a"
                      :href="chPdfUrl(CMS_API_NEWS_IMG + file.course_url)"
                      >{{
                        file.course_url ? file.course_url.substring(11) : ""
                      }}</a
                    >
                  </div>
                  <!--                 <div class="download-module-content-info-text-td" v-show="file.software_url">文件下载：<a class="download-module-a" :href="CMS_API_NEWS_IMG+file.software_url">{{file.software_url ? file.software_url.substring(12) : ''}}</a></div>
                 <div class="download-module-content-info-text-td" v-show="file.note">示例：<a class="download-module-a" :href="CMS_API_NEWS_IMG+file.note">{{file.note ? file.note.substring(12) : ''}}</a></div>-->
                  <div
                    class="download-module-content-info-text-td"
                    v-show="file.software_url"
                  >
                    文件下载：<a
                      class="download-module-a"
                      target="_blank"
                      :href="chFileUrl(file.software_url)"
                      >{{
                        file.software_url ? file.software_url.substring(57) : ""
                      }}</a
                    >
                  </div>
                  <div
                    class="download-module-content-info-text-td"
                    v-show="file.note"
                  >
                    示例：<a
                      class="download-module-a"
                      target="_blank"
                      :href="chExampleUrl(file.note)"
                      >{{ file.note ? file.note.substring(60) : "" }}</a
                    >
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <div style="text-align: center; margin: auto; margin-top: 10px">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[7, 10, 50, 100]"
              :page-size="pageSize"
              :hide-on-single-page="total < pageSize ? true : false"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              background
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { moduleDownload } from "../../helpers/moduleDownload";
import { MODULE_DOWNLOAD, CMS_API_NEWS_IMG } from "../../helpers/consts";
import { mapState } from "vuex";

export default {
  name: "companyIntroduce",
  data() {
    return {
      moduleDownload,
      MODULE_DOWNLOAD,
      isShowModuleInfo: false,
      showModuleInfoId: "",
      CMS_API_NEWS_IMG,
      currentPage: 1, // 当前页数
      pageSize: 100, // 每页显示几条
      total: 0, // 总条数

      // 导航数据
      activeIndex: "12",
      showModules: [],
      moduleName: "使用MODULE",
    };
  },
  computed: {
    ...mapState({
      modules: (state) => state.Module.modules.info,
    }),
    pageData() {
      // console.log("this.showModules: ", this.showModules)
      window.vue = this;
      // console.log(this.showModules.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize))
      return this.showModules.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    },
  },
  created() {
    this.$store.dispatch("getModule").then((res) => {
      // console.log(this.modules)
      this.showModules = [...this.modules];
      this.total = this.showModules.length;
      // console.log(this.total);
      // console.log("this.showModules: ", this.showModules)
    });
  },
  methods: {
    chPdfUrl(str) {
      return str
        ? str.replace(
            "//www.pwmat.com/upload/module/pdf",
            "//www.pwmat.com/modulefiles/pwmat-resource/module-download7/pdf"
          )
        : str;
    },
    chFileUrl(str) {
      return str
        ? str.replace(
            "http://www.pwmat.com/pwmat-resource/module-download/file",
            "//www.pwmat.com/modulefiles/pwmat-resource/module-download7/file"
          )
        : str;
    },
    chExampleUrl(str) {
      return str
        ? str.replace(
            "http://www.pwmat.com/pwmat-resource/module-download/example",
            "//www.pwmat.com/modulefiles/pwmat-resource/module-download7/example"
          )
        : str;
    },
    showModuleInfo($id) {
      if (this.isShowModuleInfo && this.showModuleInfoId === $id) {
        this.showModuleInfoId = "";
        this.isShowModuleInfo = false;
      } else {
        this.showModuleInfoId = $id;
        this.isShowModuleInfo = true;
      }
    },
    handleSizeChange(val) {
      // 改变每页的条数
      this.pageSize = val;
      this.currentPage = 1;
    },
    handleCurrentChange(val) {
      // 改变当前的页数
      this.currentPage = val;
    },
    // 导航选择
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
      switch (key) {
        case "1-1": // 物质结构：结构搜索
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "CALYPSO") {
              this.showModules.push(element);
            }
            if (element.name === "USPEX") {
              this.showModules.push(element);
            }
            if (
              element.name ===
              "Genetic algorithm to search global minimum structure"
            ) {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "物质结构 -> 结构搜索";
          this.currentPage = 1;
          break;

        case "1-2": // 物质结构：无序结构
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "disorder") {
              this.showModules.push(element);
            }
            if (element.name === "ATAT") {
              this.showModules.push(element);
            }
            if (
              element.name ===
              "Virtual Crystal Approximation (VCA) Calculations"
            ) {
              this.showModules.push(element);
            }
            if (element.name === "Bond switching Monte Carlo") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "物质结构 -> 无序结构";
          this.currentPage = 1;
          break;

        case "1-3": // 物质结构：分子动力学数据处理
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "RINGS") {
              this.showModules.push(element);
            }
            if (element.name === "PLUMED") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "物质结构 -> 分子动力学数据处理";
          this.currentPage = 1;
          break;

        case "1-4": // 物质结构：CIF 文件转换与结构处理
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "CIF2CELL") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "物质结构 -> CIF 文件转换与结构处理";
          this.currentPage = 1;
          break;

        case "2-1": // 电子结构及声子计算：电子结构
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "Band alignment") {
              this.showModules.push(element);
            }
            if (element.name === "BANDUP") {
              this.showModules.push(element);
            }
            if (element.name === "PDOS & fatband structure") {
              this.showModules.push(element);
            }
            if (element.name === "Band structure calculation by WKM") {
              this.showModules.push(element);
            }
            if (element.name === "U value calculation in LDA+U") {
              this.showModules.push(element);
            }
            if (element.name === "Wannier Band Interpolation") {
              this.showModules.push(element);
            }
            if (element.name === "High accurate k-point interpolation scheme") {
              this.showModules.push(element);
            }
            if (element.name === "Electron localization function（ELF）") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "电子结构及声子计算 -> 电子结构";
          this.currentPage = 1;
          break;

        case "2-2": // 电子结构及声子计算：声子计算
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "PyPWmat") {
              this.showModules.push(element);
            }
            if (element.name === "High temperature phonon calculation") {
              this.showModules.push(element);
            }
            if (element.name === "PWphono3py") {
              this.showModules.push(element);
            }
            if (element.name === "electron-phonon coupling (EPC)") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "电子结构及声子计算 -> 声子计算";
          this.currentPage = 1;
          break;

        case "3-1": // 光、磁、力学等性质：光学性质
          this.showModules = [];
          this.modules.forEach((element) => {
            if (
              element.name === "Absorption Spectrum for non-periodic systems"
            ) {
              this.showModules.push(element);
            }
            if (
              element.name ===
              "Frequency dependent dielectric function calculations for bulk systems using rt-TDDFT method"
            ) {
              this.showModules.push(element);
            }
            if (element.name === "TDDFT absorption spectrum(Linear response)") {
              this.showModules.push(element);
            }
            if (
              element.name ===
              "Frequency dependent dielectric function calculations using RPA method"
            ) {
              this.showModules.push(element);
            }
            if (
              element.name ===
              "Absorption coefficient/Extinction coefficient/Reflectivity/Refractive index/Emissivity calculations"
            ) {
              this.showModules.push(element);
            }
            if (element.name === "pw_absorption") {
              this.showModules.push(element);
            }
            if (
              element.name ===
              "infrared spectrum/born charge(finite electric field method)"
            ) {
              this.showModules.push(element);
            }
            if (element.name === "Raman") {
              this.showModules.push(element);
            }
            if (element.name === "second harmonic generation (SHG)") {
              this.showModules.push(element);
            }
            if (
              element.name ===
              "use charge density to calculate absorption spectrum for large-scale insulating systems"
            ) {
              this.showModules.push(element);
            }
            if (element.name === "excitionic state") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "光、磁、力学和极化性质 -> 光学性质";
          this.currentPage = 1;
          break;

        case "3-2": // 光、磁、力学等性质：磁学性质
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "Heisenberg exchange interaction constant") {
              this.showModules.push(element);
            }
            if (element.name === "magnetic exchange parameters") {
              this.showModules.push(element);
            }
            if (element.name === "gilbert damping constant") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "光、磁、力学和极化性质 -> 磁学性质";
          this.currentPage = 1;
          break;
        case "3-3": // 光、磁、力学等性质：力学性质
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "ELPWmat") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "光、磁、力学和极化性质 -> 力学性质";
          this.currentPage = 1;
          break;

        case "3-4": // 光、磁、力学等性质：极化性质
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "Berry Phase") {
              this.showModules.push(element);
            }
            if (element.name === "Born effective charge") {
              this.showModules.push(element);
            }
            if (element.name === "Piezoelectric tensor") {
              this.showModules.push(element);
            }
            if (element.name === "ionic dieclectric contribution") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "光、磁、力学和极化性质 -> 极化性质";
          this.currentPage = 1;
          break;

        case "4": // 缺陷性质
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "Defect Level") {
              // 6
              this.showModules.push(element);
            }
            if (element.name === "Image charge interaction correction") {
              // 49
              this.showModules.push(element);
            }
            if (element.name === "Charged defect calculation by TRSM") {
              // 32
              this.showModules.push(element);
            }
            if (element.name === "Defect Nonradiative Decay") {
              // 13
              this.showModules.push(element);
            }
            if (
              element.name === "anharmonic multi-phonon nonradiative transition"
            ) {
              // 45
              this.showModules.push(element);
            }
            if (element.name === "Charge trapping calculation") {
              // 19
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "缺陷性质";
          this.currentPage = 1;
          break;

        case "5": // 电化学性质
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "Water splitting") {
              this.showModules.push(element);
            }
            if (element.name === "Pourbaix diagram") {
              this.showModules.push(element);
            }
            if (element.name === "Hybrid solvent model") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "电化学性质";
          this.currentPage = 1;
          break;

        case "6": // 输运性质
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "Boltzwann") {
              this.showModules.push(element);
            }
            if (element.name === "BoltzTraP") {
              this.showModules.push(element);
            }
            if (element.name === "EMC") {
              this.showModules.push(element);
            }
            if (element.name === "Electrical conductivity") {
              this.showModules.push(element);
            }
            if (
              element.name === "Anomalous Hall Conductivity（AHC）calculation"
            ) {
              this.showModules.push(element);
            }
            if (
              element.name ===
              "Anomalous Hall Conductivity（new interpolation method）"
            ) {
              this.showModules.push(element);
            }
            if (element.name === "Spin Hall Effect（SHC）") {
              this.showModules.push(element);
            }
            if (/pwmat_transport/.test(element.name)) {
              this.showModules.push(element);
            }
            // if(element.name ==="pwmat_transport(20220823)") {
            //   this.showModules.push(element);
            // }
            if (element.name === "NONEQUILIBRIUM_SCF") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "输运性质";
          this.currentPage = 1;
          break;

        case "7": // 超快动力学过程
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "TDDFT Carrier Cooling") {
              this.showModules.push(element);
            }
            if (element.name === "Boltzman-NAMD") {
              this.showModules.push(element);
            }
            if (element.name === "Ion collision simulation by rt-TDDFT") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "超快动力学过程";
          this.currentPage = 1;
          break;
        case "8": // Beyond DFT
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "RPA_correlation_energy") {
              this.showModules.push(element);
            }
            if (element.name === "YAMBO") {
              this.showModules.push(element);
            }
            if (element.name === "BSE-YAMBO") {
              this.showModules.push(element);
            }
            if (element.name === "PWmat_BSE") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "Beyond DFT";
          this.currentPage = 1;
          break;

        case "9": // 电子束辐照分解
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "Cross Section calculation") {
              this.showModules.push(element);
            }
            if (element.name === "TDDFT Carrier Cooling") {
              this.showModules.push(element);
            }
            if (element.name === "Auger Decay Rate calculation") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "电子束辐照分解";
          this.currentPage = 1;
          break;

        case "10": // 大体系计算
          this.showModules = [];
          this.modules.forEach((element) => {
            if (
              element.name ===
              "Charge Patching Method (updated 20200316: update EXTRACT_DETAIL in patch.input)"
            ) {
              this.showModules.push(element);
            }
            if (element.name === "Charge Patching Method introduction (CPM)") {
              this.showModules.push(element);
            }
            if (element.name === "DFTB") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "大体系计算";
          this.currentPage = 1;
          break;
        case "11": // 机器学习力场
          this.showModules = [];
          this.modules.forEach((element) => {
            if (element.name === "MLFF") {
              this.showModules.push(element);
            }
            if (element.name === "MLFF on_the_fly test") {
              this.showModules.push(element);
            }
          });
          this.total = this.showModules.length;
          this.moduleName = "机器学习力场";
          this.currentPage = 1;
          break;
        case "12": // 所有模块
          this.showModules = this.modules; // 这是浅拷贝, showModules 是 modules 的引用
          // this.showModules = this.modules.slice(0)  // 数组里有对象，也不行
          /*             this.showModules = [];
            this.modules.forEach(element => {
                this.showModules.push(element);
            }); */
          this.total = this.showModules.length;
          this.moduleName = "所有模块";
          this.currentPage = 1;
          break;
      }
    },
  },
};
</script>

<style scoped>
.download-module-container {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}
.download-module-background {
  margin-top: 70px;
}
.download-module-banner {
  overflow: hidden;
}
.download-module-banner-title {
  font-size: 24px;
  font-family: PingFangSC-Semibold, sans-serif;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 50px;
  position: absolute;
  margin-top: 60px;
}
.download-module-banner-img {
  min-width: 100%;
  height: 165px;
}
.download-module-content {
  margin-top: 30px;
  margin-bottom: 90px;
}
.download-module-content-title {
  padding-top: 50px;
}
.download-module-content-title-text {
  font-size: 30px;
  font-family: PingFangSC-Medium, sans-serif;
  font-weight: 500;
  color: rgba(73, 145, 201, 1);
  line-height: 50px;
}
.download-module-content-info {
  margin-top: 40px;
}
.download-module-content-info-text {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
}
.download-module-content-info-text-td {
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(79, 76, 77, 1);
  line-height: 25px;
  margin-top: 4px;
  margin-bottom: 4px;
}
.download-module-line {
  height: 1px;
  background: rgba(240, 240, 240, 1);
  margin-top: 8px;
}
.download-module-content-img {
  text-align: center;
}
.download-module-content-img-png {
  /* margin-top: 7px; */
  width: 700px;
}
.download-module-table {
  width: 100%;
  border: 1px solid rgba(240, 240, 240, 1);
}
.download-module-th {
  background: rgba(73, 145, 201, 1);
  height: 45px;
}
.download-module-td {
  cursor: pointer;
  height: 45px;
}
.download-module-td:hover {
  background: rgba(73, 145, 201, 0.15);
}
.download-module-td-info {
  height: 45px;
  padding: 16px 32px;
  background: rgba(73, 145, 201, 0.05);
}
.download-module-text-th {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  padding: 8px 16px;
}
.el-menu-demo {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 46px !important;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 25px;
  padding: 8px 16px;
}
.download-module-text-td {
  border: 1px solid rgba(240, 240, 240, 1);
  font-size: 16px;
  font-family: PingFangSC-Regular, sans-serif;
  font-weight: 400;
  line-height: 25px;
  padding: 8px 16px;
}
.download-module-a {
  color: rgba(73, 145, 201, 1) !important;
}

@media screen and (max-width: 482px) {
  .download-module-container {
    max-width: 100%;
  }
}
@media screen and (min-width: 482px) and (max-width: 768px) {
  .download-module-container {
    max-width: 450px;
  }
}
@media screen and (min-width: 768px) and (max-width: 1100px) {
  .download-module-container {
    max-width: 736px;
  }
}
@media screen and (min-width: 1100px) and (max-width: 1444px) {
  .download-module-container {
    max-width: 1068px;
  }
}
@media screen and (min-width: 1444px) {
  .download-module-container {
    max-width: 1068px;
  }
}
</style>
